import Api from "@root/components/api";

export default class TournamentMutation {    
    async loadTournaments() {
        let query = `query() {
            tournaments {
                id name description started finished startTime
            }
        }`;
        let result = await Api.postData('/g', { query: query, variables: {} });
        if (result.errors) {
            return;
        }
        return result.data.tournaments;        
    }    
   
    async loadTournament(id) {
        let query = `query($id: String!) {
            tournament(id: $id) {
                id name description started finished startTime
                prototypeChallengeInstance {id}
                challenges {
                    id name pin startTime finishTime started finished gameIndex 
                    state joinUrl challengeType
                    miniBoss {
                        win bossHealth round teamName duration bossMaxHealth
                    }
                    participants {
                        id online levelCompletions totalPoints robot spentInOtherApp
                        miniBoss { 
                            role health maxHealth energy maxEnergy
                        }
                        user { id visualName }
                    }
                }
            }
        }`;
        let result = await Api.postData('/g', { query: query, variables: {id: id} });
        if (result.errors) {
            return;
        }
        return result.data.tournament;        
    }    

    async add(tournament) {
        let query = `mutation ($input: TournamentInput!) {
            saveTournament(input: $input) {
                id
            }
        }`;
        
        const result = await Api.postData('/g', { query: query, variables: {
            input: {
                id: tournament.id,
                name: tournament.name,
                description: tournament.description,
                challengeId: tournament.challengeId,
            },
        }});    
        return result.data.saveTournament;
    }
    
    async addChallenge(id, pin) {
        let query = `mutation ($id: String!, $pin: String!) {
            addTournamentChallenge(id: $id, pin: $pin)
        }`;
        
        const result = await Api.postData('/g', { query: query, variables: {
            id: id,
            pin: pin,
        }});    
        return result.data.addTournamentChallenge;
    }

    async removeChallenge(id, challengeId) {
        let query = `mutation ($id: String!, $challengeId: String!) {
            removeTournamentChallenge(id: $id, challengeId: $challengeId)
        }`;
        
        const result = await Api.postData('/g', { query: query, variables: {
            id: id,
            challengeId: challengeId,
        }});    
        return result.data.removeTournamentChallenge;
    }

    async start(id) {
        let query = `mutation ($id: String!) {
            startTournament(id: $id)
        }`;
        
        const result = await Api.postData('/g', { query: query, variables: { id: id }});    
        return result.data.startTournament;
    }

    async reset(id) {
        let query = `mutation ($id: String!) {
            resetTournament(id: $id)
        }`;
        
        const result = await Api.postData('/g', { query: query, variables: { id: id }});    
        return result.data.resetTournament;
    }

    async finish(id) {
        let query = `mutation ($id: String!) {
            finishTournament(id: $id)
        }`;
        
        const result = await Api.postData('/g', { query: query, variables: { id: id }});    
        return result.data.finishTournament;
    }
}